export const encodingConstants = {
    H264: "H264",
    H265: "H265"
}

export const resolutionConstants = {
    SD: "704x480",
    HD: "1280x720",
    twoMP: "1920x1080",
    fourMP: "2560x1440",
    fiveMP: "2560x1920",
    fourK: "3840x2160",
    WSVGA: "1024x640",
    sqrRes: "800x800",
    FullHD: "800x450",
    ToIsTo1: "1280x640"


}